import { render } from "./TrainingView.vue?vue&type=template&id=0fec723b&scoped=true"
import script from "./TrainingView.vue?vue&type=script&lang=js"
export * from "./TrainingView.vue?vue&type=script&lang=js"

import "./TrainingView.vue?vue&type=style&index=0&id=0fec723b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fec723b"]])

export default __exports__